import styles from './index.module.scss'

export function ProgressSkeleton(props: any) {
  // eslint-disable-next-line react/destructuring-assignment
  return <div className={styles.progress}>{props.children}</div>
}
